import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { trigger, transition, animate, style, state } from '@angular/animations';
import { AuthorizationService } from '../../core/services/authorization.service';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { componentDestroyed } from '@w11k/ngx-componentdestroyed';
import { first } from 'rxjs/operators';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css'],
  animations: [
    trigger('slideInOut', [
      state('*', style({ transform: 'translateX(0%)', opacity: 1 })),
      transition('void => *', [style({ transform: 'translateX(100%)', opacity: 0 }), animate(500)]),
      transition('* => void', animate(500, style({ transform: 'translateX(100%)', opacity: 0 })))
    ])
  ]
})

export class HeaderComponent implements OnInit, OnDestroy {
  user: any;
  show: boolean = false;
  changeForm: FormGroup;
  submitted = null;
  visible: boolean = true;

  constructor(
    private authService: AuthorizationService,
    private router: Router,
    private formBuilder: FormBuilder,
    private toastrService: ToastrService
  ) {
    this.createForm();
  }

  ngOnInit() {
    this.user = this.authService.retrieveUserDetails();
  }

  ngOnDestroy() {

  }

  createForm() {
    this.changeForm = this.formBuilder.group({
      oldPassword: ['', Validators.required],
      newPassword: ['', Validators.required],
      confirmPassword: ['', Validators.required]
    }, {
      validator: this.passwordValidator
    });
  }


  logout() {
    this.authService.logout();
    this.router.navigate(['login']);
  }

  changePassword() {
    this.submitted = false;
    if (this.changeForm.invalid) {
      return
    }
    this.submitted = true;
    if (this.changeForm.valid) {
      this.authService.changePassword(this.changeForm.value)
        .pipe(first())
        .takeUntil(componentDestroyed(this))
        .subscribe(res => {
          this.toastrService.success('password has been changed');
        });
      this.changeForm.reset();
    }
  }
  
  get f() { return this.changeForm.controls }

  passwordValidator(form: FormGroup) {
    const condition = form.get('newPassword').value !== form.get('confirmPassword').value;
    return condition ? { passwordsDoNotMatch: true } : null;
  }

  isControlHasError(controlName: string, validationType: string): boolean {
    const control = this.changeForm.controls[controlName];
    if (!control) {
      return false;
    }
    const result = control.hasError(validationType) && (control.dirty || control.touched);
    return result;
  }

}
